



















































import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import { Task } from "@/api/task-api";
import ITaskOutputOptions from "@/api/models/ITaskOutputOptions";

import CheckDayOfWeek from "@/components/CheckDayOfWeek.vue";
import VTaskSubtaskControl from "./VTaskSubtaskControl.vue";
import parseDateTime from "../../helpers/parseDateTime";
import formatDateTime from "../../helpers/formatDateTime";
import ProjectManagerApi from "@/api/gateways/project-manager-api";
import ProjectWorkerApi from "@/api/gateways/project-worker-api";
import ProjectWorker from "@/entities/project-worker";
import ProjectManager from "@/entities/project-manager";
import { getAllClientStaffs } from "@/api/client-api";

interface UserOption {
  id: string | number;
  name: string;
}

@Component({
  components: {
    CheckDayOfWeek,
    VTaskSubtaskControl
  }
})
export default class VTaskControl extends Vue {
  @Prop({ required: true }) task!: Task;
  @Prop({ required: true }) options!: ITaskOutputOptions;

  get start(): string {
    return formatDateTime(this.task.start);
  }

  set start(start: string) {
    this.task.start = parseDateTime(start);
  }

  get end(): string {
    return formatDateTime(this.task.end);
  }

  set end(end: string) {
    this.task.end = parseDateTime(end);
  }

  validateDate() {
    const end = this.$refs.end as HTMLInputElement;
    if (this.task.start > this.task.end) {
      end.setCustomValidity("終了日は開始日以降に設定してください");
    } else {
      end.setCustomValidity("");
    }
  }

  @Watch("options.hasSubTasks")
  private initSubTask(hasSubTasks: boolean) {
    if (!hasSubTasks) return;
    if (!this.task.subTasks.length) {
      const user = this.$store.state.user;

      this.task.subTasks.push({
        taskId: "",
        name: "",
        done: false,
        behind: false,
        created: new Date(),
        dueDate: "",
        userName: "",
        date: "",
        time: "",
        users: [
          {
            id: user.staffId,
            name: user.name
          }
        ]
      });
    }
    this.$nextTick(() => {
      (this.$refs.subtasks as VTaskSubtaskControl).focus();
    });
  }

  users: UserOption[] = [] as UserOption[];
  async created() {
    const user = this.$store.state.user;
    this.users = [
      {
        id: user.staffId,
        name: user.name
      }
    ];

    const clientStaffList = ((await getAllClientStaffs(
      this.$route.params.projectId
    )) as unknown) as {
      staffId: string | number;
      name: string;
      isHiddenInfo: boolean;
    }[];
    clientStaffList.forEach(
      (item: {
        staffId: string | number;
        name: string;
        isHiddenInfo: boolean;
      }) => {
        if (item.staffId != user.staffId && !item.isHiddenInfo) {
          this.users.push({
            id: item.staffId,
            name: item.name
          });
        }
      }
    );
    const pm = new ProjectManagerApi(
      this.$store.getters.api,
      Number(this.$route.params.projectId)
    );
    const pw = new ProjectWorkerApi(
      this.$store.getters.api,
      Number(this.$route.params.projectId)
    );
    const resPm = await pm.assigned();
    resPm.forEach((item: ProjectManager) => {
      if (item.id != user.staffId && !item.isHiddenInfo) {
        this.users.push({
          id: item.id,
          name: item.name
        });
      }
    });
    const resPw = await pw.assigned();
    resPw.forEach((item: ProjectWorker) => {
      if (item.id != user.staffId && !item.isHiddenInfo) {
        this.users.push({
          id: item.id,
          name: item.name
        });
      }
    });
  }
}
